/*
 * Jira Ticket:
 * Created Date: Wed, 1st Apr 2020, 10:52:51 am
 * Author: Jessica Mowatt
 * Email: jessica.mowatt@thedistance.co.uk
 * Copyright (c) 2020 The Distance
 */

const goBack = () => {
  window.history.go(-1);
};

export default goBack;
